<template>
  <!-- App de celular: tela de bloqueio ao voltar do segundo plano (useBiometricLogin.ts, startAppLock). -->
  <div v-if="appLocked" class="al-overlay" role="dialog" aria-modal="true" aria-label="WootDash bloqueado">
    <div class="al-box">
      <img :src="logoUrl" alt="" class="al-logo" />
      <h2>WootDash bloqueado</h2>
      <p>Use a digital ou a senha do celular pra voltar às conversas.</p>
      <button type="button" class="al-btn" :disabled="busy" @click="unlock">{{ busy ? 'Aguardando…' : 'Desbloquear' }}</button>
      <button type="button" class="al-link" :disabled="busy" @click="logout">Sair e entrar com a senha</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { appLocked, unlockApp } from '@/composables/useBiometricLogin'
import { performLogout } from '@/composables/useAutoLogout'
import { useLogo } from '@/composables/useLogo'

const store = useStore()
const router = useRouter()
const { logoUrl } = useLogo()
const busy = ref(false)

async function unlock() {
  busy.value = true
  await unlockApp()
  busy.value = false
}

async function logout() {
  appLocked.value = false
  await performLogout(store, router)
}
</script>

<style scoped>
.al-overlay { position: fixed; inset: 0; z-index: 100000; display: flex; align-items: center; justify-content: center; padding: 24px; background: #F0F2F5; }
.al-box { width: 100%; max-width: 360px; display: flex; flex-direction: column; align-items: center; gap: 12px; text-align: center; }
.al-logo { height: 56px; margin-bottom: 8px; }
.al-box h2 { margin: 0; font: 700 20px 'Poppins', sans-serif; color: #1f2937; }
.al-box p { margin: 0 0 8px; font-size: 14px; color: #6b7280; line-height: 1.5; }
.al-btn { width: 100%; padding: 13px 16px; border: 0; border-radius: 10px; background: #BC0C24; color: #fff; font: 600 15px 'Poppins', sans-serif; cursor: pointer; }
.al-btn:disabled { opacity: .5; }
.al-link { border: 0; background: none; color: #6b7280; font: 500 13px 'Poppins', sans-serif; text-decoration: underline; cursor: pointer; padding: 6px; }
</style>
